import { makeStyles } from '@material-ui/core';
import { Icon } from '@material-ui/core';
import React from 'react';
import useWidth from 'v2/hooks/useWidth';

export interface IMyTableHeaderIndex {
  title?: string;
  callback?: (index: number) => void;
  numeric?: boolean;
  ordering?: boolean | 'asc' | 'desc';
  el?: JSX.Element;
}

interface IProps {
  index?: IMyTableHeaderIndex[];
  ordering?: boolean | 'asc' | 'desc';
  ordered?: number;
  onChangeOrder?: (item: IMyTableHeaderIndex, index: number) => void;
}

const useStyles = makeStyles((theme) => ({
  tHead: {
    fontSize: theme.typography.fontSize,
    fontWeight: 400,
  },
  th: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    fontSize: theme.typography.fontSize,
    textAlign: 'left',
    lineHeight: 1.3,
    ['&.numeric' as any]: {
      textAlign: 'right',
    },
    ['&:first-child' as any]: {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
      paddingLeft: theme.spacing(2),
      ['&.status ' as any]: {
        paddingLeft: 0,
        paddingRight: 16,
      },
    },
    ['&:last-child' as any]: {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
      paddingRight: theme.spacing(2),
    },
    ['&.ordering' as any]: {
      cursor: 'pointer',
    },
  },
}));

const MyTableHeader = ({ index, ordering, ordered, onChangeOrder }: IProps) => {
  const width = useWidth();
  const classes = useStyles({});

  const handleChangeOrder = (item: IMyTableHeaderIndex, index: number) => {
    return () => {
      item.callback && item.callback(index);
      onChangeOrder && onChangeOrder(item, index);
    };
  };

  if (width === 'md' || width === 'lg' || width === 'xl') {
    return (
      <thead className={classes.tHead}>
        <tr>
          {index &&
            index.map((item, index) => (
              <th
                key={`index-${index}`}
                className={classes.th + (item.numeric ? ' numeric' : '') + (item.ordering ? ' ordering' : '')}
                onClick={handleChangeOrder(item, index)}
              >
                {!!item.title && item.title}
                {!item.title && item.el && item.el}

                {ordering && ordered === index ? (
                  ordering === 'asc' ? (
                    <Icon style={{ marginLeft: 4, fontSize: 14, position: 'relative', top: 1 }}>arrow_upward</Icon>
                  ) : (
                    <Icon style={{ marginLeft: 4, fontSize: 14, position: 'relative', top: 1 }}>arrow_downward</Icon>
                  )
                ) : (
                  ''
                )}
              </th>
            ))}
        </tr>
      </thead>
    );
  }

  return <div></div>;
};

export default MyTableHeader;
